import React from 'react';
import { Mail, Phone, MapPin, Linkedin, Twitter, Github } from 'lucide-react';
import logo from '../assets/Keltnine-AI-transparent.png';

const Footer: React.FC = () => {
  const footerSections = [
    {
      title: 'Services',
      links: [
        { name: 'Document AI', href: '#' },
        { name: 'Custom Development', href: '#' },
        { name: 'Cloud Support', href: '#' },
        { name: 'AI Consulting', href: '#' }
      ]
    },
    {
      title: 'Company',
      links: [
        { name: 'About', href: '#' },
        { name: 'Careers', href: '#' },
      ]
    },
    {
      title: 'Resources',
      links: [
        { name: 'Case Studies', href: '#' },
        { name: 'Support', href: '#' },
      ]
    }
  ];

  const contactInfo = [
    { icon: Mail, text: 'info@keltnine.ai', href: 'mailto:info@keltnine.ai' },
    { icon: MapPin, text: 'Tyson Corner, VA', href: '#' }
  ];

  const socialLinks = [
    { icon: Linkedin, href: '#', label: 'LinkedIn' },
    { icon: Twitter, href: '#', label: 'Twitter' },
    { icon: Github, href: 'https://github.com/keltnine', label: 'GitHub' }
  ];

  return (
    <footer className="bg-black border-t border-dark-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center mb-4">
              <img 
                src={logo} 
                alt="Keltnine" 
                className="w-12 h-10 mr-3"
              />
              <h3 className="text-2xl font-bold font-display gradient-text">
                Keltnine
              </h3>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Building the future of AI agents for every use case. We specialize in document intelligence, 
              custom SaaS development, and enterprise automation solutions.
            </p>
            <div className="space-y-3">
              {contactInfo.map((contact) => (
                <a
                  key={contact.text}
                  href={contact.href}
                  className="flex items-center text-gray-400 hover:text-white transition-colors duration-200"
                >
                  <contact.icon size={16} className="mr-3" />
                  {contact.text}
                </a>
              ))}
            </div>
          </div>

          {/* Footer Links */}
          {footerSections.map((section) => (
            <div key={section.title}>
              <h4 className="text-white font-semibold mb-4">{section.title}</h4>
              <ul className="space-y-2">
                {section.links.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.href}
                      className="text-gray-400 hover:text-white transition-colors duration-200"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Section */}
        <div className="border-t border-dark-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex items-center space-x-6 mb-4 md:mb-0">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  className="text-gray-400 hover:text-white transition-colors duration-200"
                  aria-label={social.label}
                >
                  <social.icon size={20} />
                </a>
              ))}
            </div>
            
            <div className="text-center md:text-right">
              <p className="text-gray-400 text-sm mb-2">
                Building the future of AI agents
              </p>
              <div className="flex items-center justify-center md:justify-end space-x-4 text-xs text-gray-500">
                <span>© 2025 Keltnine AI Consulting</span>
                <span>•</span>
                <a href="#" className="hover:text-gray-400 transition-colors duration-200">
                  Privacy Policy
                </a>
                <span>•</span>
                <a href="#" className="hover:text-gray-400 transition-colors duration-200">
                  Terms of Service
                </a>
              </div>
            </div>
          </div>

          {/* Compliance Badges */}
          <div className="flex flex-wrap justify-center md:justify-end items-center space-x-4 mt-6">
            <div className="flex items-center space-x-2 text-xs text-gray-500">
              <div className="w-3 h-3 bg-accent-500 rounded-full"></div>
              <span>GDPR Ready</span>
            </div>
            <div className="flex items-center space-x-2 text-xs text-gray-500">
              <div className="w-3 h-3 bg-primary-600 rounded-full"></div>
              <span>AWS Partner</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 